import { Icon } from "leaflet";
import store from "../store";
import proj4 from "proj4";
import { env } from "../env";

export const mapService = {
  initProjections,
  checkCoordinates,
  setDefaultIcons,
  setMapLayout,
  getMultipolygonCenter
};

// Définitions des différentes projections
function initProjections() {
  const projections = store.getters.projections;

  const proj4Projections = [];
  for(let epsg in projections) {
    proj4Projections.push(projections[epsg].proj4);
  }

  proj4.defs(proj4Projections);
}

// /!\ Notifications non-centralisées
function checkCoordinates(parcId, x, y) {
  const url = new URL(`${env.apiUrl}/parcs/${parcId}/validation-localisation`);

  if (x !== null && y !== null) {
    url.searchParams.append("long", x);
    url.searchParams.append("lat", y);
  }

  const requestOptions = {
    method: "GET",
    headers: {
      Authorization: "Bearer " + store.getters.token,
      Profil: store.getters.profil
    }
  };

  return fetch(url, requestOptions)
    .then(response => {
      return response;
    })
    .catch(err => {
      console.log(err);
    });
}

//Hack pour afficher les icônes par défaut
//https://vue2-leaflet.netlify.app/quickstart/#marker-icons-are-missing
function setDefaultIcons() {
  delete Icon.Default.prototype._getIconUrl;
  Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png")
  });
}

//Hack pour afficher la carte en taille totale
// https://github.com/vue-leaflet/Vue2Leaflet/issues/96
function setMapLayout() {
  setTimeout(function() {
    window.dispatchEvent(new Event("resize"));
  }, 250);
}

function getMultipolygonCenter(multipolygon) {
  var twoTimesSignedArea = 0;
  var cxTimes6SignedArea = 0;
  var cyTimes6SignedArea = 0;

  var length = multipolygon.length;

  var x = function(i) {
    return multipolygon[i % length][0];
  };
  var y = function(i) {
    return multipolygon[i % length][1];
  };

  for (var i = 0; i < multipolygon.length; i++) {
    var twoSA = x(i) * y(i + 1) - x(i + 1) * y(i);
    twoTimesSignedArea += twoSA;
    cxTimes6SignedArea += (x(i) + x(i + 1)) * twoSA;
    cyTimes6SignedArea += (y(i) + y(i + 1)) * twoSA;
  }
  var sixSignedArea = 3 * twoTimesSignedArea;
  return [
    cxTimes6SignedArea / sixSignedArea,
    cyTimes6SignedArea / sixSignedArea
  ];
}
